import type {
  FinancialSituationInput,
  FinancialSituationValueResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<FinancialSituationValueResponse>(
    `${BASE}/${instanceId}/financial-situation/flow-instance-value`,
  );
}

export function saveFlowInstanceValue(instanceId: string, input: FinancialSituationInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/financial-situation/flow-instance-value`,
    input,
  );
}
